import {
  NBS_WS_AUTH_DONE_RECEIVED,
  NBS_WS_COUNTERS_RECEIVED,
  NBS_WS_FLIRTS_UPDATE_RECEIVED,
  NBS_WS_VIP_UPDATE,
  NBS_WS_PRIVATE,
  NBS_WS_STOP_AND_DONT_RECONNECT,
  NBS_WS_GET_CHAT_HISTORY,
  NBS_WS_GET_CHAT_HISTORY_SUCCESS,
  NBS_WS_SEND_MESSAGE_SUCCESS,
  RESET_STOP_AND_DONT_RECONNECT,
  SET_MISSING_PHOTO_MODAL,
  RESET_MISSING_PHOTO_MODAL,
  NBS_WS_INVALID_TOKEN,
  NBS_WS_AUTH_BLOCKED,
  DELETE_ACTION_REQUIRED,
  NBS_WS_VIP_3DSV2_UPDATE_SUCCESS,
  NBS_WS_3DSV2_UPDATE_FAILED,
  RESET_FINISH_WEB_PAYMENT,
  NBS_WS_3DSV2_UPDATE_PROCESSING,
  RESET_WS_3DSV2_UPDATE_PROCESSING,
  DELETE_ALL_ACTIONS_REQUIRED,
} from '../../constants/actions';

const initialState = {
  isOpen: null,
  authDone: {},
  counters: {},
  flirtsUpdate: {},
  vipUpdate: {},
  privateUpdate: {},
  anotherClientConnected: false,
  missingPhotoModal: 0,
  invalidToken: false,
  authBlocked: false,
  lastEvent: null,
  lastEventTime: null,
  lastEventData: {},
  isFetching: false,
  threedsv2UpdateSuccess: {},
  threedsv2UdpateFailed: null,
  threedsv2UpdateProcessing: false,
};

export default function reducer(state = initialState, action = {}) {
  const { authDone, counters, flirtsUpdate } = state;
  const { data } = action;
  switch (action.type) {
    case NBS_WS_AUTH_DONE_RECEIVED:
      const newAuthData = { ...authDone, ...data };
      return {
        ...state,
        authDone: newAuthData,
        isOpen: true,
        lastEvent: data.event,
        lastEventTime: Date.now(),
        lastEventData: data,
      };
    case NBS_WS_GET_CHAT_HISTORY:
      return { ...state, isFetching: true };
    case NBS_WS_GET_CHAT_HISTORY_SUCCESS:
    case NBS_WS_SEND_MESSAGE_SUCCESS:
      return {
        ...state,
        lastEvent: data.event,
        lastEventTime: Date.now(),
        lastEventData: data,
        isFetching: false,
      };
    case NBS_WS_COUNTERS_RECEIVED:
      const newCountersData = { ...counters, ...data };
      return {
        ...state,
        counters: newCountersData,
        lastEvent: data.event,
        lastEventTime: Date.now(),
        lastEventData: data,
      };
    case NBS_WS_FLIRTS_UPDATE_RECEIVED:
      const newFlirtsUpdateData = { ...flirtsUpdate, ...data };
      return {
        ...state,
        flirtsUpdate: newFlirtsUpdateData,
        lastEvent: data.event,
        lastEventTime: Date.now(),
        lastEventData: data,
      };
    case NBS_WS_VIP_UPDATE:
      return {
        ...state,
        vipUpdate: action.data,
        lastEvent: data.event,
        lastEventTime: Date.now(),
        lastEventData: data,
      };
    case NBS_WS_VIP_3DSV2_UPDATE_SUCCESS:
      // console.log('SOCKET REDUCER:::::', action);
      return { ...state, threedsv2UpdateSuccess: action.data };
    case NBS_WS_3DSV2_UPDATE_PROCESSING:
      return { ...state, threedsv2UpdateProcessing: true };
    case RESET_WS_3DSV2_UPDATE_PROCESSING:
      return { ...state, threedsv2UpdateProcessing: false };
    case NBS_WS_3DSV2_UPDATE_FAILED:
      return { ...state, threedsv2UdpateFailed: action.data };
    case RESET_FINISH_WEB_PAYMENT:
      return { ...state, threedsv2UdpateFailed: null };
    case NBS_WS_PRIVATE:
      return {
        ...state,
        privateUpdate: action.data,
        lastEvent: data.event,
        lastEventTime: Date.now(),
        lastEventData: data,
      };
    case NBS_WS_STOP_AND_DONT_RECONNECT:
      return {
        ...state,
        anotherClientConnected: true,
        lastEvent: null,
        lastEventTime: Date.now(),
        lastEventData: {},
      };
    case RESET_STOP_AND_DONT_RECONNECT:
      return {
        ...state,
        anotherClientConnected: false,
        lastEvent: null,
        lastEventTime: Date.now(),
        lastEventData: {},
      };
    case SET_MISSING_PHOTO_MODAL:
      const nextAuthData = { ...authDone };
      const filteredActions = authDone.actions_required.filter(
        (a) => a !== 'show_initial_upgrade'
      );
      nextAuthData.actions_required = filteredActions;
      return {
        ...state,
        authDone: nextAuthData,
        missingPhotoModal: action.data.missingPhotoModal,
        lastEvent: data.event,
        lastEventTime: Date.now(),
        lastEventData: data,
      };
    case RESET_MISSING_PHOTO_MODAL:
      return {
        ...state,
        missingPhotoModal: 0,
        lastEvent: data.event,
        lastEventTime: Date.now(),
        lastEventData: data,
      };
    case NBS_WS_INVALID_TOKEN:
      return {
        ...state,
        invalidToken: true,
        lastEvent: data.event,
        lastEventTime: Date.now(),
        lastEventData: data,
      };
    case NBS_WS_AUTH_BLOCKED:
      return {
        ...state,
        authBlocked: true,
        lastEvent: data.event,
        lastEventTime: Date.now(),
        lastEventData: data,
      };
    case DELETE_ACTION_REQUIRED:
      const newData = {
        ...state,
        lastEvent: null,
        lastEventTime: Date.now(),
        lastEventData: {},
      };
      const deleteActions = authDone.actions_required.filter(
        (a) => a !== action.deleteActionRequired
      );
      newData.authDone.actions_required = [...deleteActions];

      return newData;
    case DELETE_ALL_ACTIONS_REQUIRED:
      return {
        ...state,
        authDone: { ...state.authDone, actions_required: [] },
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/socket.js